import { Injectable } from '@angular/core';
import { QuoteService } from '../quote/quote.service';
import { QuoteQuestionDropDownAutocompleteDataLoaderService } from './quote-question-drop-down-autocomplete-data-loader.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteQuestionDropDownAutocompleteDataLoaderFactoryService {

  constructor(private quoteService: QuoteService) { }

  createInstance(dropDownId: number)
  {
    let dataLoader = new QuoteQuestionDropDownAutocompleteDataLoaderService(this.quoteService);
    dataLoader.dropDownId = dropDownId;
    return dataLoader;
  }
}
